module.exports = __webpack_public_path__ + "ffd63d5c3b1092df4263d7d1d9e1b69c.svg";